import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Label } from "@fluentui/react/lib/Label";
import { SpinButton } from "@fluentui/react/lib/SpinButton";
import { Stack } from "@fluentui/react/lib/Stack";

import { IconButtonWithTooltip } from "Components/Generic/IconButtonWithTooltip";
import { IWithThemeProps } from "Components/Generic/Theme/IWithThemeProps";
import { WithTheme } from "Components/Generic/Theme/WithTheme";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { uiRefreshEveryTimeSet } from "Store/Actions";
import { selectRefreshEveryTime } from "Store/Selectors/UI";
import { useAutoRefreshStyles } from "./UseAutoRefreshStyles";

export const AutoRefresh = WithTheme(
  WithTranslator((props: IWithTranslatorProps & IWithThemeProps): JSX.Element => {
    const {
      translator,
      theme: { spacing }
    } = props;
    const dispatch = useDispatch();
    const styles = useAutoRefreshStyles();
    const time = useSelector(selectRefreshEveryTime);

    const onChange = useCallback(
      (_, value: string) => {
        try {
          dispatch(uiRefreshEveryTimeSet(parseInt(value, 10)));
        } catch {
          dispatch(uiRefreshEveryTimeSet(60));
        }
      },
      [dispatch]
    );

    const onClick = useCallback(() => {
      dispatch(uiRefreshEveryTimeSet(60));
    }, [dispatch]);

    return (
      <Stack horizontal tokens={{ childrenGap: spacing.m }}>
        <Stack.Item grow>
          <Label>{translator.get(`settings.autorefresh.time.label`, `Time between automatic refresh:`)}</Label>
        </Stack.Item>
        <Stack.Item grow={false} className={styles.input}>
          <SpinButton min={15} max={3600} step={5} precision={0} value={time.toString()} onChange={onChange} />
        </Stack.Item>
        <Stack.Item grow={false}>
          <IconButtonWithTooltip
            iconProps={{ iconName: `RevToggleKey` }}
            tooltip={translator.get(`general.resetdefault`, `Reset to default`)}
            onClick={onClick}
          />
        </Stack.Item>
      </Stack>
    );
  })
);
